import React, { useState } from "react";
import ContactUsModal from "../ContactUsModal/contactUsModal";

/**
 * The reference design has a "Newsletter" email-signup form here, but there's no real
 * subscription backend anywhere in this app (checked) -- even the reference's own form was a
 * no-op (`onSubmit={(e) => e.preventDefault()}`). Rather than ship a fake signup box that goes
 * nowhere, this reuses the same real ContactUsModal already wired up on the Pricing/FAQ pages.
 */
const BlogsContactCTA: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <section className="bp-contact">
      <div className="bp-contact__card">
        <div className="bp-contact__glow bp-contact__glow--1" />
        <div className="bp-contact__glow bp-contact__glow--2" />
        <div className="bp-contact__content">
          <h3 className="bp-contact__heading">Have a story idea or feedback?</h3>
          <p className="bp-contact__lede">
            We&apos;d love to hear from you. Drop us a note and we&apos;ll get back within one
            business day.
          </p>
          <button type="button" className="bp-contact__btn" onClick={() => setOpen(true)}>
            Contact us
            <span aria-hidden="true">→</span>
          </button>
        </div>
      </div>

      <ContactUsModal open={open} setOpen={setOpen} />
    </section>
  );
};

export default BlogsContactCTA;
